
// import styled, { createGlobalStyle } from 'styled-components';

// export const GlobalStyles = createGlobalStyle`
//   * {
//     margin: 0;
//     padding: 0;
//     box-sizing: border-box;
//   }

//   body {
//     font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
//     background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
//     color: #111113ff;
//     line-height: 1.5;
//     overflow: hidden; /* Prevent scrolling on body */
//   }

//   /* Metallic texture overlay */
//   body::before {
//     content: '';
//     position: fixed;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background: 
//       radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
//       radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%),
//       radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.2) 0%, transparent 50%),
//       linear-gradient(135deg, rgba(120, 119, 198, 0.1) 0%, rgba(255, 119, 198, 0.1) 100%);
//     background-blend-mode: overlay;
//     pointer-events: none;
//     z-index: -1;
//   }

//   /* Hide scrollbars but allow scrolling */
//   * {
//     -ms-overflow-style: none; /* IE and Edge */
//     scrollbar-width: none; /* Firefox */
//   }
  
//   *::-webkit-scrollbar {
//     display: none; /* Chrome, Safari and Opera */
//   }

//   /* Ensure no overflow on root elements */
//   html, body, #root {
//     height: 100%;
//     overflow: hidden;
//   }
// `;

// export const AppContainer = styled.div`
//   display: flex;
//   min-height: 100vh;
//   background: transparent;
//   overflow: hidden; /* Prevent container scrolling */
// `;

// export const MainContent = styled.main`
//   flex: 1;
//   padding: ${props => props.isLoginScreen ? '0' : '1.5rem 2.5rem'};
//   height: 100vh;
//   overflow-y: ${props => props.isLoginScreen ? 'hidden' : 'auto'}; /* Only allow scrolling on non-login screens */
//   display: flex;
//   align-items: ${props => props.isLoginScreen ? 'center' : 'flex-start'};
//   justify-content: ${props => props.isLoginScreen ? 'center' : 'flex-start'};
//   position: relative;

//   @media (max-width: 768px) {
//     padding: ${props => props.isLoginScreen ? '1rem' : '1rem'};
//     height: ${props => props.isLoginScreen ? '100vh' : 'auto'};
//     min-height: calc(100vh - 60px);
//   }
// `;

// export const theme = {
//   colors: {
//     primary: '#3B82F6',
//     secondary: '#6B7280',
//     dark: {
//       800: '#1F2937',
//       700: '#374151',
//       600: '#4B5563',
//       900: '#cacbccff'
//     },
//     blue: {
//       400: '#60A5FA',
//       500: '#3B82F6',
//       600: '#2563EB',
//       700: '#1D4ED8'
//     },
//     // metallic: {
//     //   primary: 'linear-gradient(135deg, #111213ff 100%',
//     //   secondary: 'linear-gradient(135deg, #0d0d0eff 0%, #f5576c 100%)',
//     //   accent: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
//     // }
//   }
// };













import styled, { createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    background: #f8fafc; /* unified slate-50 */
    color: #0f172a; /* unified slate-900 */
    line-height: 1.5;
    overflow: hidden;
  }
  /* Scrollbar styling */
  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  *::-webkit-scrollbar-track {
    background: rgba(31, 41, 55, 0.5);
  }
  
  *::-webkit-scrollbar-thumb {
    background: rgba(120, 119, 198, 0.5);
    border-radius: 3px;
  }
  
  *::-webkit-scrollbar-thumb:hover {
    background: rgba(120, 119, 198, 0.7);
  }
`;
export const AppContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: transparent;
  overflow: hidden;
`;
export const MainContent = styled.main`
  flex: 1;
  padding: ${props => props.isLoginScreen ? '0' : '0'};
  height: ${props => props.isWorkspaceScreen ? '100%' : '100vh'};
  overflow-y: ${props => props.isWorkspaceScreen ? 'hidden' : 'auto'};
  display: flex;
  flex-direction: column;
  width: ${props => props.isWorkspaceScreen ? '100%' : '80%'};
  @media (max-width: 1024px) {
    width: 100%;
    padding-top: ${props => props.isWorkspaceScreen ? '0' : '60px'}; /* Space for fixed header on mobile/tablet */
    height: ${props => props.isWorkspaceScreen ? '100%' : 'calc(100vh - 60px)'};
  }
  @media (max-width: 768px) {
    padding-top: ${props => props.isWorkspaceScreen ? '0' : '60px'};
    height: ${props => props.isWorkspaceScreen ? '100%' : 'calc(100vh - 60px)'};
  }
`;
export const theme = {
  breakpoints: {
    tablet: '768px',
    mobile: '480px',
  },
  colors: {
    primary: '#3B82F6',
    secondary: '#6B7280',
    dark: {
      800: '#1F2937',
      700: '#374151',
      600: '#4B5563',
      900: '#111827'
    },
    blue: {
      400: '#60A5FA',
      500: '#3B82F6',
      600: '#2563EB',
      700: '#1D4ED8'
    },
    lavender: 'rgba(120, 119, 198, 0.3)',
    text: '#e6eef7',
    card: '#1a2236',
    accent: '#1e88ff',
    muted: '#6b7280',
    green: '#2ecc71',
    yellow: '#f4b740',
  }
};
